function constructQueryStringFromObject(query) {
  let queryString = ""
  Object?.keys(query).forEach((key) => {
    if (key !== "slug") {
      queryString =
        queryString +
        `${queryString.length === 0 ? "" : "&"}${key}=${encodeURIComponent(
          query[key]
        )}`
    }
  })
  return queryString
}

import { PureComponent } from "react"
import { Query, Mutation } from "react-apollo"
import gql from "graphql-tag"
import Link from "next/link"

import "./ideas-pagination.scss"
import { LOCAL_TOGGLE_OVERLAY_MUTATION } from "../../apollo-state/graphql/mutations"

const PAGINATION_QUERY = gql`
  query ideasConnection {
    usersLookingForIdeaConnection {
      aggregate {
        count
      }
    }
  }
`

class Pagination extends PureComponent {
  render() {
    const { usersPerPage, pageNumber, variables, me } = this.props
    return (
      <div className="pagination">
        <Query query={PAGINATION_QUERY} variables={variables}>
          {({ data, loading, error }) => {
            if (loading) return <span />
            if (error) return <span />
            const { count } = data.usersLookingForIdeaConnection.aggregate
            const pages = Math.ceil(count / usersPerPage)
            console.log(pageNumber, pages, "here")
            return (
              <>
                {pageNumber > 1 && (
                  <Link href={`/ideas?page=${pageNumber - 1}`}>
                    <a className="pagination__prev-next">← Prev</a>
                  </Link>
                )}
                {pageNumber < pages && (
                  <Mutation mutation={LOCAL_TOGGLE_OVERLAY_MUTATION}>
                    {(signUp) => (
                      <>
                        {me ? (
                          <Link href={`/ideas?page=${pageNumber + 1}`}>
                            <a className="pagination__prev-next">More →</a>
                          </Link>
                        ) : (
                          <button
                            onClick={signUp}
                            className="pagination__prev-next"
                          >
                            More →
                          </button>
                        )}
                      </>
                    )}
                  </Mutation>
                )}
                {me && pages > 0 && (
                  <div className="pagination__details">
                    page <strong>{pageNumber}</strong> of{" "}
                    <strong>{pages}</strong>
                  </div>
                )}
              </>
            )
          }}
        </Query>
      </div>
    )
  }
}

export default Pagination
